import React, { FunctionComponent, useEffect } from 'react';

import cn from 'classnames';
import { useSelector } from 'react-redux';

import { Button, SvgImage } from '../../../../shared/components';
import { i18n } from '../../../../shared/helpers/i18n';
import { countMetrika } from '../../../../shared/helpers/metrika';
import { ACCEPTABLE_RATINGS } from '../../constants';
import { selectHasSummarizationFeedbackChatSection } from '../../features/user-feedback/selectors';
import { SummarizationFeedback, UserFeedbackProps } from '../../types';
import css from './styles.css';

type SummarizationFeedbackBannerProps = UserFeedbackProps<SummarizationFeedback>;

const CHAT_URL = 'https://nda.ya.ru/t/5nxCZ8WU7BVepY';

export const SummarizationFeedbackBanner: FunctionComponent<SummarizationFeedbackBannerProps> = ({ feedback }) => {
    const hasChatSection = useSelector(selectHasSummarizationFeedbackChatSection);
    const { type, summarizationId, rating } = feedback;

    useEffect(() => {
        if (summarizationId && rating && ACCEPTABLE_RATINGS.has(rating)) {
            countMetrika(`${type}_feedback`, summarizationId, rating);
        }
    }, [type, summarizationId, rating]);

    const containerClasses = cn(css.container, {
        [css.withChatSection]: hasChatSection,
    });

    return (
        <main className={containerClasses}>
            <div className={css.wrapper}>
                <section className={css.gratitudeSection}>
                    <div className={css.imageWrapper}>
                        <span>
                            <SvgImage imageName="summarizationBanner" />
                        </span>
                    </div>
                    <h2 className={css.gratitudeHeader}>{i18n('summarization', 'feedback-header')}</h2>
                    <p className={css.gratitudeDescription}>{i18n('summarization', 'feedback-content-v2')}</p>
                </section>
                {hasChatSection && (
                    <section className={css.chatSection}>
                        <div className={css.chatContent}>
                            <h3 className={css.chatHeader}>{i18n('summarization', 'feedback-chat-section-title')}</h3>
                            <p className={css.chatDescription}>
                                {i18n('summarization', 'feedback-chat-section-description')}
                            </p>
                        </div>
                        <Button
                            view="brand"
                            elementType="a"
                            href={CHAT_URL}
                            target="_blank"
                            size="md"
                            className={css.chatJoinButton}
                        >
                            {i18n('summarization', 'feedback-chat-section-join')}
                        </Button>
                    </section>
                )}
            </div>
        </main>
    );
};
